import React from "react";
import { Create, SimpleForm } from 'react-admin';

import { SaveWithCancelToolbar } from '../../../components/toolbars/SaveWithCancelToolbar';

import { ArticleTemplateBaseForm } from '../Forms/ArticleTemplateBaseForm';


export const ArticleTemplateCreate = (props) => (
	<Create {...props}>
		<SimpleForm submitOnEnter={false} toolbar={<SaveWithCancelToolbar />} redirect="list">
			<ArticleTemplateBaseForm />
		</SimpleForm>
	</Create>
);
